import { AnyAction } from "redux"
import { ThunkAction } from "redux-thunk"
import {
    SharedStoreState,
    TPayment,
    endpointsShared,
    requestThunk,
} from ".."
import { providerActions, providerSelectors } from "../store/providerSlice"
import { IProviderConfig, EProviderConfigType, EProviderName } from "../types/provider/IProvider"

export const fetchProviderConfigsThunk =
    (merchantId: string,
        force: boolean
    ): ThunkAction<void, SharedStoreState, null, AnyAction> => async (dispatch, getState) => {
        if (!force && providerSelectors.configs(getState(), merchantId)) {
            return
        }

        const resp = await dispatch(
            requestThunk<{ configs: IProviderConfig[] }>(endpointsShared.Providers.getConfigs, {
                params: { merchantId },
            })
        )

        dispatch(
            providerActions.setConfigs({
                merchantId,
                configs: resp.configs,
            })
        )
    }

// export const addProviderConfig =
//     (
//         merchantId: string,
//         webshopId: string | undefined,
//         type: EProviderConfigType,
//         preferredProvider: EProviderName,
//         paymentType: TPayment | undefined
//     ): ThunkAction<void, SharedStoreState, null, AnyAction> =>
//     async (dispatch, getState) => {
//         const resp = await dispatch(
//             requestThunk<{}>(endpointsShared.Providers.addConfig, {
//                 data: {
//                     merchantId,
//                     webshopId,
//                     type: type,
//                     preferredProvider: preferredProvider,
//                     paymentType: paymentType
//                 },
//             })
//         )

//         dispatch(
//             providerActions.setConfigs({
//                 merchantId,
//                 configs: resp.configs,
//             })
//         )
//     }